import { AboutPage } from './../../about/about.page';
import { HotelListPage } from './../hotel-list/hotel-list.page';
import { DeleteRoomModalComponent } from './../../package-details/package-booking/delete-room-modal/delete-room-modal.component';
import { DateRangePicker } from './../../../shared/date-range-picker.component';
import { CalendarComponentOptions } from 'ion2-calendar';
import { Component, Input, OnInit } from '@angular/core';
import {
  AlertController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import * as moment from 'moment';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { PlainScorecard, PlayerRoundScores } from 'src/data/handicap-history';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { getNestedValue } from 'src/providers/common-service';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { Router } from '@angular/router';
import { DeleteAccountModalComponent } from './delete-account-modal/delete-account-modal.component';
import {
  CompetitionData,
  CountryData,
  CustomizedAttributes,
  initTravelInfoForm,
  LeagueSeason,
  LeagueSeasonParticipantView,
  LeagueSettings,
  MCTPlayerTravelInfo,
  MCTPlayerTravelInfoForm,
  PlayerData,
  PlayerHomeInfo,
  PlayerInfo,
  TournamentHotel,
  TournamentPlayerBasicView,
} from 'src/data/mygolf.data';
import { finalize, Subscription, Observable, BehaviorSubject } from 'rxjs';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CompetitionService } from 'services/competition-service/competition-service';
import { CommonPullupMenuComponent } from '../common-pullup-menu/common-pullup-menu.component';
import { AppCustomizerService } from 'src/providers/app-customizer-service/app-customizer.service';
import { Browser } from '@capacitor/browser';
import * as globals from 'src/globals';
import { TextValidator } from 'src/custom/field-validator';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ImageZoomPage } from '../image-zoom/image-zoom.page';
import { MultiCourseCompetitionService } from 'services/multi-course-competition-service/multi-course-competition.service';
import { HotelDetailsComponent } from '../hotel-details/hotel-details.component';

@Component({
  selector: 'app-competition-travel-update',
  templateUrl: './competition-travel-update.page.html',
  styleUrls: ['./competition-travel-update.page.scss'],
})
export class CompetitionTravelUpdateModalPage implements OnInit {
  public title: string;
  public descriptionText: string;
  public headerName: string;
  public scorecard: PlainScorecard;

  myTime: any = moment();
  teeTime: Date = new Date(); //string; //Date = new Date();
  prevTeeTime: Date; // = new Date();
  myTDate: string; //Date;// = new Date();
  prs: PlayerRoundScores;
  prevTdate: string;

  accountDeletionType: string = 'deactivate';

  appAttribute: any;
  accountDeactivateAtt: any;
  accountDeleteAtt: any;
  accountDeleteSuccessMessage: any = '';

  // Track subscriptions for cleanup to prevent memory leaks
  private updateSubscriptions: Subscription[] = [];

  @Input() formDefinition: any;
  @Input() formId: any;
  @Input() playerAdditionalInfo: any;
  @Input() compData: CompetitionData;
  @Input() player: any; //PlayerHomeInfo;
  @Input() requireMandatory: boolean = false;
  @Input() viewMode: boolean = true;
  @Input() sctOrMct: string = 'sct';
  @Input() leagueSeason: LeagueSeason;
  @Input() allowedForms: Array<string>;
  @Input() titleHeader: string = null;
  @Input() formFirstRegister: boolean = false;
  @Input() rosterDetails: TournamentPlayerBasicView = null;
  travelStartDate: string;
  travelEndDate: string;
  arrivalDate: string;
  arrivalTime: string = '';
  departureDate: string;
  departureTime: string = '';

  highlightedDates: any[];

  @Input() jumpTo: string = '';
  msgLockStayDetails = 'This Country has been locked from Accomodation Details changes';
  maxExpiryDate: string;

  // selectedSharingRoomWith: PlayerInfo | PlayerData;
  constructor(
    public nav: NavController,
    private navParams: NavParams,
    private modalCtl: ModalController,
    private router: Router,
    private toastCtl: ToastController,
    private platform: Platform,
    private mg2uUtil: mygolfUtils,
    private alertCtrl: AlertController,
    private flightService: ClubFlightService,
    private compService: CompetitionService,
    private customizerService: AppCustomizerService,
    private sanitizer: DomSanitizer,
    private multiCourseCompService: MultiCourseCompetitionService
  ) {
    this.title = this.navParams.get('title');
    this.descriptionText = this.navParams.get('description');
    this.headerName = this.navParams.get('headerName');
    this.scorecard = this.navParams.get('scorecard');
    this.appAttribute = this.mg2uUtil.getAppAttribute();

    this.teeTime = this.myTime;

    this.prevTeeTime = this.teeTime;
    this.prevTdate = this.myTDate;
    this.maxExpiryDate = moment().add(20, 'years').format('YYYY-MM-DD');

    if (this.appAttribute) {
      this.appAttribute
        .filter(att => att.page === 'accountOptions')
        .map(att => {
          console.log('7777777777', att);

          if (att && att.deactivate) {
            this.accountDeactivateAtt = att.deactivate;
          }
          console.log('this.accountDeactivateAtt: ', this.accountDeactivateAtt);
          if (att && att.delete) {
            this.accountDeleteAtt = att.delete;
          }
          console.log('this.accountDeleteAtt: ', this.accountDeleteAtt);
          if (att && att.processedMessage) {
            this.accountDeleteSuccessMessage = att.processedMessage;
          }
        });
    }

    this.customizerService.getSubsidiary().subscribe(subsidiary => {
      if (globals.appType === 'main') {
      } else {
        this.currentSubsidiary = subsidiary;
        console.debug('current subsidiary : ', subsidiary, globals.appType);
      }
    });
    console.debug('current roster details : ', this.rosterDetails, this.player);

    // this.multiCourseCompService.getSeasonDetails().subscribe((leagueSeason: LeagueSeason) => {
    //   console.debug('mct season details : ', leagueSeason);
    //   // this.leagueSeason = leagueSeason;
    //   // this.leagueSettings = leagueSeason?.leagueSettings;
    // });
  }
  leagueSettings: LeagueSettings;
  playerIsRegistered: boolean = false;
  currentSubsidiary: string;
  async ngOnInit() {
    if (this.leagueSeason?.leagueSettings) {
      this.leagueSettings = this.leagueSeason.leagueSettings;
    }
    this.inputPlayerTravelForm = initTravelInfoForm();

    // this.inputPlayerTravelForm.arrivalDate = moment().format('YYYY-MM-DD');
    // this.inputPlayerTravelForm.departureDate = moment().format('YYYY-MM-DD');
    // this.inputPlayerTravelForm.passportExpiry = moment().format('YYYY-MM-DD');

    this.getCountryList();
    this.refreshParticipantsList();
    this.getAllHotelRoomAllocations();
    this.refreshParticipatingClubs();
    this.multiCourseCompService.refreshPlayerTravelInfo(
      this.leagueSeason?.id,
      this.rosterDetails?.player?.id
    );
    this.getPlayerTravelInfo();

    this.travelStartDate = this.leagueSettings?.travelStartDate; //  moment('2026-07-01').format('YYYY-MM-DD');
    this.travelEndDate = this.leagueSettings?.travelEndDate; //moment('2026-07-15').format('YYYY-MM-DD');

    console.debug(
      'travel start date ',
      this.travelStartDate,
      this.travelEndDate,
      this.leagueSettings
    );
    this.highlightedDates = [
      {
        date: this.leagueSeason?.startDate,
        textColor: '#800080',
        backgroundColor: '#ffc0cb',
      },
      {
        date: this.leagueSeason?.endDate,
        textColor: '#09721b',
        backgroundColor: '#c8e5d0',
      },
    ];

    this.multiCourseCompService.getSelectedHotelRoom().subscribe(hotelRoom => {
      if (hotelRoom) {
        const hotel = hotelRoom?.hotel;
        const room = hotelRoom?.room;
        console.debug('selected travel hotel room :', hotelRoom, hotel, room);
        if (hotel) {
          this.selectedHotel = {
            id: hotel?.id,
            name: hotel?.hotel?.name,
            data: hotel,
          };
          this.inputPlayerTravelForm.tournamentHotelId = hotel?.id;
          // this.getHotelDetails(hotel?.id);
        }

        if (room) {
          this.selectedHotelRoom = {
            id: room?.id,
            name: room?.hotelRoom?.roomName,
            data: room,
          };

          this.inputPlayerTravelForm.tournamentHotelRoomId = room?.id;
          this.getHotelRoomAllocations(this.selectedHotelRoom);
          this.getSpecificRoomAllocated();
        }
        this.multiCourseCompService.setSelectedHotelRoom(null);
      }
    });

    // await this.getCustomizedAttributes();
    // await this.getPlayerDetails();
    // if (this.formDefinition) {
    //   // const sourceFormDefinition = JSON.parse(this.formDefinition);
    //   const formDef = JSON.parse(JSON.stringify(this.formDefinition));
    //   this.compAddlInfoForm = this.constructDynamicForms(formDef);
    //   console.debug(
    //     'comp form : ',
    //     this.compAddlInfoForm,
    //     this.formDefinition,
    //     this.playerAdditionalInfo
    //   );
    //   this.parseFormDefinition();
    // }
    // if (!this.playerAdditionalInfo) {
    //   this.initPlayerForm();
    // } else {
    //   this.populatePlayerForm();
    // }
    console.debug('roster details view mode : ', this.viewMode);
  }

  ngAfterViewInit() {
    // Scroll to section specified by jumpTo input when modal opens
    if (this.jumpTo) {
      // Use setTimeout to ensure modal content is fully rendered before scrolling
      setTimeout(() => {
        this.scrollToSection(this.jumpTo);
      }, 500);
    }
  }

  close() {
    this.myTDate = this.prevTdate;
    this.teeTime = this.prevTeeTime;
    this.modalCtl.dismiss(null);
  }

  onApplyClick() {
    if (1) {
      return false;
    }
    let valid: boolean = true;
    let currentDate = moment().format('YYYY-MM-DD');
    let currentTime = moment().format('HH:mm');

    let selDate = moment(this.myTDate).format('YYYY-MM-DD');
    let selTime = moment(this.teeTime).format('HH:mm');

    console.log('apply click current date/time:', currentDate, ',', currentTime);
    console.log('apply click selected date/time:', selDate, ',', selTime);

    this.scorecard.playedOn = this.myTDate;

    if (selDate > currentDate) {
      valid = false;
    } else if (selDate == currentDate && selTime > currentTime) {
      valid = false;
    }

    if (!valid) {
      let subTitle = 'Please set tee-off date and time in the past or today';
      MessageDisplayUtil.showErrorToast(subTitle, this.platform, this.toastCtl, 3000, 'bottom');
      return false;
    }

    if (this.scorecard.playerRoundScores.length > 0) {
      this.scorecard.playerRoundScores.forEach((prs: PlayerRoundScores) => {
        if (!prs.actualStartTime) {
          prs.actualStartTime = moment(this.teeTime, 'HH:mm').format('HH:mm');
        }

        if (!prs.startTime) {
          console.log('valid Time');
          prs.startTime = moment(this.teeTime, 'HH:mm').format('HH:mm');
        } else {
          console.log('else');
          prs.startTime = moment(this.teeTime, 'YYYY-MM-DDTHH:mm:ssZ').format('HH:mm');
        }
      });
    }

    this.modalCtl.dismiss({ scorecard: this.scorecard });
  }

  getInnerHTML() {
    let description =
      "<p><span style='background-color:#00FFFF'>Tournaments, electronic scorecards, analysis and more&hellip; Look no further! myGolf2u is a single place where you can find and register for any </span>competitions in your region, your favourite clubs or in the entire country on your phone or in this site.</p>";
    return description;
  }

  async onClickCancel() {
    if (0) {
      // this.uploadedPassportFiles?.length
      const _header = 'Pending Upload Document';
      let _msg = 'You still have pending document(s) to be uploaded. Do you want to upload?';
      const _subMsg = '';
      const modal = await this.modalCtl.create({
        component: CommonPullupMenuComponent, // DeleteRoomModalComponent,
        backdropDismiss: false,
        // showBackdrop:true,
        mode: 'ios',
        cssClass: this.platform.is('mobile')
          ? 'self-adjustable-modal'
          : 'self-adjustable-modal-desktop',
        componentProps: {
          mode: 'negative-confirmation',
          headerTitle: _header,
          confirmMessage: _msg,
        },
      });
      await modal.present();
      modal.onDidDismiss().then(data => {
        console.debug('prompt dismiss : ', data);
        if (data) {
          if (data?.data) {
            this.onClickUpload();
          } else {
            this.modalCtl.dismiss();
          }
        }
      });
    } else {
      this.modalCtl.dismiss();
    }
  }

  async onClickProceed() {
    let _accountDeletionType = '';
    if (this.accountDeletionType === 'deactivate') {
      _accountDeletionType = 'deactivating';
    } else if (this.accountDeletionType === 'delete') {
      _accountDeletionType = 'deleting';
    }
    let _message = 'Do you want to proceed with ' + _accountDeletionType + ' your account?';
    const modal = await this.modalCtl.create({
      component: DeleteAccountModalComponent,
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      mode: 'ios',
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then(data => {
      if (data?.data) {
        this.goAccountDeletion();
      }
    });
    //   let alert =await this.alertCtrl.create({
    //       header: 'Confirmation',
    //       message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
    //       buttons: [{
    //           text: 'No'
    //       },{
    //           text: 'Yes',
    //           handler: () => {
    //               this.goAccountDeletion();
    //           }
    //       }]
    //   });
    //   alert.present();
  }

  goAccountDeletion() {
    let _msg = '';
    const self = this;
    this.flightService.userRequestAccountDeletion().subscribe({
      next(result) {
        if (result) {
          _msg =
            'Successfully requested for account deletion. This process might take 6-7 days to process';
        } else {
          _msg = 'There was an error. Please try again after a few moments.';
        }
      },
      error() {
        _msg = 'There was an error. Please try again after a few moments.';
      },
      async complete() {
        const modal = await self.modalCtl.create({
          component: DeleteAccountModalComponent,
          cssClass: self.platform.is('mobile')
            ? 'self-adjustable-modal'
            : 'self-adjustable-modal-desktop',
          componentProps: {
            modeFrom: 'confirmDelete',
            msg: _msg,
          },
          mode: 'ios',
        });
        await modal.present().then(() => {
          const height = self.platform.height() - 250;
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        });

        modal.onDidDismiss().then(data => {
          console.debug('dismiss submit acount deletion request', data);
          setTimeout(() => {
            self.modalCtl.dismiss();
          }, 500);
        });
      },
    });

    //   .subscribe((result)=>{
    //       console.debug("request account deletion : ", result)
    //       if(result) {
    //            _msg = 'Successfully requested for account deletion. This process might take 6-7 days to process';
    //           if(this.accountDeleteAtt && this.accountDeleteAtt.processedMessage) _msg = this.accountDeleteAtt.processedMessage;

    //         //   MessageDisplayUtil.showErrorToast(_msg,this.platform, this.toastCtl,3000, 'bottom');

    //           this.modalCtl.dismiss({needRefresh: true});
    //       } else {
    //         _msg = 'There was an error. Please try again after a few moments.'
    //         //   MessageDisplayUtil.showErrorToast(_msg,this.platform, this.toastCtl,3000, 'bottom');
    //       }
    //   },(error)=>{
    //       if(error) {
    //         _msg = 'There was an error. Please try again after a few moments.'
    //         // MessageDisplayUtil.showErrorToast(_msg,this.platform, this.toastCtl,3000, 'bottom');
    //       }
    //   })
  }

  goCheckNHSNumber() {
    const url = 'http://nhs.mgaonline.com.my/';
    window.open(url, '_system');
  }

  subUpdateAddInfo: Subscription;
  validateMessage: string[] = [];
  async onValidateForm() {
    this.validateMessage = [];
    try {
      let _validate: boolean = true;
      // if(this.inputPlayerTravelForm) {
      //   for(let key in this.inputPlayerTravelForm) {
      //     const exclude = key === 'passportImages' ||
      //     key === 'foodPreference' ||
      //     key === 'roomAllocationId' ||
      //     key === 'insuranceCopy'
      //     if(!exclude) {

      //     }
      //   }
      // }
      const arrivingFlightNumber = this.inputPlayerTravelForm.arrivingFlightNumber;
      if (
        (!TextValidator.isBlank(arrivingFlightNumber) &&
          TextValidator.isOnlyZeros(arrivingFlightNumber)) ||
        TextValidator.contains000(arrivingFlightNumber)
      ) {
        this.validateMessage.push(`Arriving Flight Number is invalid`);
        _validate = false;
      }
      const departingFlightNumber = this.inputPlayerTravelForm.departingFlightNumber;
      if (
        (!TextValidator.isBlank(departingFlightNumber) &&
          TextValidator.isOnlyZeros(departingFlightNumber)) ||
        TextValidator.contains000(departingFlightNumber)
      ) {
        this.validateMessage.push(`Departing Flight Number is invalid`);
        _validate = false;
      }

      if (this.selectedHotel && !this.selectedHotelRoom) {
        this.validateMessage.push(`Please select a Hotel Room`);
        _validate = false;
      }
      const passportNumber = this.inputPlayerTravelForm.passportNumber;
      if (
        (!TextValidator.isBlank(passportNumber) && TextValidator.isOnlyZeros(passportNumber)) ||
        TextValidator.contains000(passportNumber)
      ) {
        this.validateMessage.push(`Passport Number is invalid`);
        _validate = false;
      }
      const insuranceProvider = this.inputPlayerTravelForm.insuranceName;
      if (!TextValidator.isBlank(insuranceProvider)) {
        if (
          TextValidator.isOnlyZeros(insuranceProvider) ||
          TextValidator.contains000(insuranceProvider) ||
          !TextValidator.isValidText(insuranceProvider)
        ) {
          this.validateMessage.push(`Insurance Provider is invalid`);
          _validate = false;
        }
      }
      const insuranceNumber = this.inputPlayerTravelForm.insuranceNumber;
      if (!TextValidator.isBlank(insuranceNumber)) {
        if (
          TextValidator.isOnlyZeros(insuranceNumber) ||
          TextValidator.contains000(insuranceNumber)
        ) {
          this.validateMessage.push(`Insurance Number is invalid`);
          _validate = false;
        }
      }
      if (this.inputPlayerTravelForm.emergencyContactDetails !== undefined) {
        const contactName = this.inputPlayerTravelForm.emergencyContactDetails?.contactName;
        const contactRelation = this.inputPlayerTravelForm.emergencyContactDetails?.relation;
        const contactPhone = this.inputPlayerTravelForm.emergencyContactDetails?.contactPhone;
        const contactEmail = this.inputPlayerTravelForm.emergencyContactDetails?.contactEmail;

        if (!TextValidator.isBlank(contactName)) {
          if (
            TextValidator.isOnlyZeros(contactName) ||
            TextValidator.contains000(contactName) ||
            !TextValidator.isValidText(contactName)
          ) {
            this.validateMessage.push(`Contact Name is invalid`);
            _validate = false;
          }
        }

        if (!TextValidator.isBlank(contactRelation)) {
          if (
            TextValidator.isOnlyZeros(contactRelation) ||
            TextValidator.contains000(contactRelation) ||
            !TextValidator.isValidText(contactRelation)
          ) {
            this.validateMessage.push(`Contact Relationship is invalid`);
            _validate = false;
          }
        }
        if (
          (!TextValidator.isBlank(contactPhone) && TextValidator.isOnlyZeros(contactPhone)) ||
          TextValidator.contains000(contactPhone)
        ) {
          this.validateMessage.push(`Contact Phone is invalid`);
          _validate = false;
        }
        if (!TextValidator.isBlank(contactEmail)) {
          if (
            TextValidator.isOnlyZeros(contactEmail) ||
            TextValidator.contains000(contactEmail) ||
            !TextValidator.isValidEmail(contactEmail)
          ) {
            this.validateMessage.push(`Contact Email is invalid`);
            _validate = false;
          }
        }
      }

      // if (this.playerForm) {
      //   // await this.compAddInfoForm?.formObj.fields.forEach(fld => {
      //   await this.formDefinition?.fields.forEach(fld => {
      //     const _playerField = this.playerForm[fld.name];
      //     if (
      //       fld.required &&
      //       (this.playerForm[fld.name]?.length === 0 ||
      //         this.playerForm[fld.name] === null ||
      //         this.playerForm[fld.name] === undefined ||
      //         this.playerForm[fld.name]?.toLowerCase() === 'null' ||
      //         TextValidator.isBlank(this.playerForm[fld.name]))
      //     ) {
      //       // console.debug(
      //       //   'validate add info [0]: ',
      //       //   fld,
      //       //   this.playerAdditionalInfo[fld.name]?.length
      //       // );
      //       this.validateMessage.push(`${fld.label} is mandatory`);
      //       _validate = false;
      //     }
      //     // if (
      //     //   fld.required &&
      //     //   fld.type === 'options' &&
      //     //   (TextValidator.isBlank(_playerField) || _playerField?.toLowerCase() === 'null')
      //     // ) {
      //     //   this.validateMessage.push(`${fld.label} is AA mandatory`);
      //     //   _validate = false;
      //     // }
      //     if (
      //       fld.required &&
      //       fld.type === 'text' &&
      //       (TextValidator.isOnlyZeros(_playerField) || TextValidator.contains000(_playerField))
      //     ) {
      //       this.validateMessage.push(`${fld.label} is invalid`);
      //       _validate = false;
      //     }
      //     if (
      //       fld.required &&
      //       fld.type === 'text' &&
      //       (fld.label?.toLowerCase()?.includes('phone') ||
      //         fld.label?.toLowerCase().includes('contact'))
      //     ) {
      //       if (!TextValidator.isValidPhone(_playerField, 8, 15)) {
      //         this.validateMessage.push(`${fld.label} is invalid`);
      //         _validate = false;
      //       }
      //     }
      //     console.debug('validating form fields : ', fld, this.playerForm, this.compAddlInfoForm);
      //     this.playerForm[fld.name] = this.playerForm[fld.name].toUpperCase();
      //   });
      // }
      return _validate;
    } catch (error) {
      return true;
    }
  }
  proceedSubmit() {
    console.debug(
      'on submit : ',
      this.formDefinition,
      this.player,
      this.playerForm,
      this.playerAdditionalInfo,
      this.sctOrMct,
      this.appAttribute,
      this.compService.getPlayerIsRegistered()
    );
    // for(const field of this.playerForm) {
    //   if(typeof this.playerForm[field]=== 'string') {
    //     this.playerForm[field] = this.playerForm[field].toUpperCase();
    //   }

    // }

    if (this.sctOrMct === 'mct') {
      const playerId = this.player?.playerId || this.player?.id;
      this.flightService
        .updateMCTPlayerAdditionalInfo(
          this.leagueSeason?.league?.organizer?.id,
          this.leagueSeason?.id,
          playerId,
          this.playerForm
        )
        .subscribe(data => {
          this.onProceedPlayerUpdates();
        });
      this.modalCtl.dismiss(true);
    } else {
      // this.subUpdateAddInfo = this.compService
      //   .getPlayerIsRegistered()
      //   .pipe(
      //     finalize(() => {
      //       if (this.subUpdateAddInfo) {
      //         this.subUpdateAddInfo.unsubscribe();
      //         this.subUpdateAddInfo = null;
      //       }
      //       this.playerForm = null;
      //     })
      //   )
      //   .subscribe(playerIsRegistered => {
      //     if (playerIsRegistered) {
      const playerId = this.player?.playerId || this.player?.id;
      if (this.formFirstRegister) {
        this.compService.getPlayerIsRegistered().subscribe(isRegistered => {
          if (isRegistered) {
            this.flightService
              .updateCompPlayerAdditionalInfo(this.compData?.id, playerId, this.playerForm)
              .subscribe(data => {
                this.onProceedPlayerUpdates();
                this.onProceedCompUpdates();
                this.compService.setPlayerIsRegistered(false);
              });
          }
        });
      } else {
        this.flightService
          .updateCompPlayerAdditionalInfo(this.compData?.id, playerId, this.playerForm)
          .subscribe(data => {
            this.onProceedPlayerUpdates();
            this.onProceedCompUpdates();
            this.compService.setPlayerIsRegistered(false);
          });
      }
      //   }
      // });

      this.modalCtl.dismiss({
        proceedRegister: true,
      });
    }
  }

  onClickUpload() {
    // const orgId: number = this.leagueSeason?.league?.organizer?.id || 0;
    // const multiCompId: number = this.leagueSeason?.id || 0;
    // const playerId = this.player?.playerId || this.player?.id;
    // const files = this.uploadedFiles?.filter(file => file.sizeInMB < 1).map(file => file.file);
    // this.flightService
    //   .uploadMCTHandicapDocuments(orgId, multiCompId, playerId, files)
    //   .subscribe(data => {
    //     if (data) this.rosterDetails = data;
    //     this.uploadedFiles = [];
    //     this.multiCourseCompService.setRefreshMCTDetails(true);
    //     MessageDisplayUtil.showMessageToast(
    //       'Successfully added document(s)',
    //       this.platform,
    //       this.toastCtl,
    //       5000,
    //       'bottom'
    //     );
    //   });
  }
  async onClickSubmit() {
    let _validateSuccess: boolean = true;
    if (this.requireMandatory) {
      _validateSuccess = await this.onValidateForm();
      if (_validateSuccess) {
        this.proceedSubmit();
      } else {
        MessageDisplayUtil.showErrorToast(
          this.validateMessage.join('<br>'),
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
      }
    } else {
      this.proceedSubmit();
    }
  }

  playerForm: any = {};
  initPlayerForm() {
    // if (!this.formDefinition) return;
    // if (this.formDefinition?.fields?.length) {
    //   this.formDefinition.fields?.forEach(fld => {
    //     if (fld.type !== 'separator') {
    //       this.playerForm[fld.name] = null;
    //     }
    //   });
    // }
    if (!this.formDefinition) {
      return;
    }
    let competitionSignUp;

    if (this.appAttribute) {
      competitionSignUp = this.appAttribute.find(
        att => att.page === 'competition'
      )?.competitionSignUp;
    }
    // console.debug(
    //   'init player form : ',
    //   this.appAttribute.find(att => att.page === 'competition'),
    //   competitionSignUp
    // );
    let playerMapping;
    if (globals.appType === 'main') {
      playerMapping = competitionSignUp?.playerMappingForms;
    } else {
      playerMapping = this.customizedAttributes?.competitionSignUp?.playerMappingForms;
    }
    const _player = this.player;
    // console.debug('init player form : ', playerMapping, this.player, _player, this.formDefinition);
    // const _playerAddlInfo = Object.assign(this.playerAdditionalInfo);
    const _fields = this.formDefinition.fields;
    _fields.forEach(fld => {
      if (fld.type !== 'separator') {
        const mappedPath = playerMapping?.[fld.name];
        const playerValue = mappedPath ? getNestedValue(_player, mappedPath) : undefined;

        if (playerValue !== undefined) {
          this.playerForm[fld.name] = playerValue;
        } else {
          if (fld.type === 'time' || fld.type === 'date' || fld.type === 'datetime') {
            // console.debug(
            //   'each field populate [0]',
            //   fld,
            //   _player[playerMapping[fld.name]],
            //   _player
            // );
          }
          // Initialize datetime fields with undefined instead of null to avoid ion-datetime errors
          // ion-datetime cannot handle empty strings - use undefined for no value
          if (fld.type === 'time' || fld.type === 'date' || fld.type === 'datetime') {
            this.playerForm[fld.name] = undefined;
          } else {
            this.playerForm[fld.name] = null;
          }
        }
      }
      // if (_playerAddlInfo[fld.name]) {
      //   this.playerForm[fld.name] = _playerAddlInfo[fld.name];
      // } else if (_player[playerMapping[fld.name]]) {
      //   this.playerForm[fld.name] = _player[playerMapping[fld.name]];
      // } else this.playerForm[fld.name] = null;
    });
  }
  populatePlayerForm() {
    if (!this.playerAdditionalInfo) {
      return;
    }
    const playerMapping = this.customizedAttributes?.competitionSignUp?.playerMappingForms;
    const _player = this.player;
    const _playerAddlInfo = Object.assign(this.playerAdditionalInfo);
    const _fields = this.formDefinition.fields;
    let _hcpUploadIndex = 0;
    _fields.forEach(fld => {
      if (fld.type === 'time' || fld.type === 'date' || fld.type === 'datetime') {
        console.debug('each field populate [1]', fld, _playerAddlInfo[fld.name], _player);
      }
      if (_playerAddlInfo[fld.name]) {
        this.playerForm[fld.name] = _playerAddlInfo[fld.name];
      } else if (playerMapping) {
        const mappedPath = playerMapping[fld.name];
        const playerValue = mappedPath ? getNestedValue(_player, mappedPath) : undefined;

        if (playerValue !== undefined) {
          this.playerForm[fld.name] = playerValue;
        } else {
          // Initialize datetime fields with undefined instead of null to avoid ion-datetime errors
          // ion-datetime cannot handle empty strings - use undefined for no value
          if (fld.type === 'time' || fld.type === 'date' || fld.type === 'datetime') {
            this.playerForm[fld.name] = undefined;
          } else {
            this.playerForm[fld.name] = null;
          }
        }
      } else {
        // Initialize datetime fields with undefined instead of null to avoid ion-datetime errors
        // ion-datetime cannot handle empty strings - use undefined for no value
        if (fld.type === 'time' || fld.type === 'date' || fld.type === 'datetime') {
          this.playerForm[fld.name] = undefined;
        } else {
          this.playerForm[fld.name] = null;
        }
      }

      if (fld.type === 'file' && fld?.properties?.image) {
        console.debug('populate image field : ', fld, _playerAddlInfo);
        if (this.temporaryImageURL[fld.name] === undefined) {
          this.temporaryImageURL[fld.name] = null;
        }
        this.temporaryImageURL[fld.name] = globals.MygolfServer + '/' + _playerAddlInfo[fld.name];
        if (fld.hcpUploadIndex !== undefined && _playerAddlInfo[fld.name]?.length) {
          this.showAdditionalHcpUpload[fld.hcpUploadIndex] = true;
        }
        console.debug('populate image field [1] : ', this.showAdditionalHcpUpload, fld);
      } else if (fld.type === 'file') {
        if (this.temporaryImageURL[fld.name] === undefined) {
          this.temporaryImageURL[fld.name] = null;
        }
        this.temporaryImageURL[fld.name] = globals.MygolfServer + '/' + _playerAddlInfo[fld.name];
        if (fld.hcpUploadIndex !== undefined && _playerAddlInfo[fld.name]?.length) {
          this.showAdditionalHcpUpload[fld.hcpUploadIndex] = true;
        }
        if (_playerAddlInfo[fld.name]?.length) {
          this.showAdditionalHcpUpload[fld.hcpUploadIndex] = true;
          let _addHcpUpload = this.showAddHcpUpload.find(hcpUpload => {
            return hcpUpload.name === fld.name;
          });
          if (_addHcpUpload) {
            _addHcpUpload.show = true;
          } else {
            this.showAddHcpUpload.push({
              idx: fld.hcpUploadIndex,
              name: fld.name,
              show: true,
            });
          }
        }
      }
      console.debug('populating form [00]', fld, _playerAddlInfo, _player, playerMapping);
      // console.debug(
      //   'populating form [000]',
      //   fld.name,
      //   _playerAddlInfo[fld.name],
      //   _player[playerMapping[fld.name]],
      //   playerMapping[fld.name]
      // );
    });

    //! display handicap upload
    // this.compAddlInfoForm.fields.forEach(fld => {
    //   if (fld.type === 'file' && fld?.properties?.image) {
    //     if (fld.hcpUploadIndex !== undefined) {
    //       this.showAdditionalHcpUpload[fld.hcpUploadIndex].show = true;
    //     }
    //   }
    // });

    // for (let [key, value] of Object.entries(this.playerAdditionalInfo)) {
    //   if (!this.playerForm[key] || this.playerForm[key] === undefined) {
    //     this.playerForm[key] = null;
    //   }

    //   if (!value) {
    //     for (let [key2, value2] of Object.entries(playerMapping)) {
    //       console.debug(
    //         'populating form from attributes ',
    //         playerMapping,
    //         key,
    //         value,
    //         key2,
    //         value2
    //       );
    //       if (key2 === key) {
    //         // this.playerForm[key2] = this.player[value2];
    //       }
    //     }
    //   } else this.playerForm[key] = value;
    //   console.debug(
    //     'populating form [0]',
    //     key,
    //     value,
    //     this.formDefinition,
    //     this.playerAdditionalInfo,
    //     this.playerForm,
    //     this.playerAdditionalInfo[key],
    //     this.playerForm[key],
    //     playerMapping
    //   );
    // }
  }

  parseTextWithLinks(text: string): string {
    if (!text) {
      return '';
    }

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.replace(
      urlRegex,
      url => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
    );
  }

  clonedFormDefinition;
  parseFormDefinition() {
    this.clonedFormDefinition = null;
    this.clonedFormDefinition = JSON.parse(JSON.stringify(this.formDefinition));
    if (this.clonedFormDefinition?.fields?.length) {
      this.clonedFormDefinition.fields.forEach(fld => {
        fld.hint = this.parseTextWithLinks(fld.hint);
        fld.tooltip = this.parseTextWithLinks(fld.tooltip);
      });
    }
  }

  async onClickTooltip(field) {
    let _message = {
      title: field?.label,
      content: field?.tooltip,
    };

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        message: _message,
        mode: 'infoDisplay',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {});
  }

  customizedAttributes: CustomizedAttributes;
  getCustomizedAttributes() {
    this.customizerService.getCustomizedAttributes().subscribe(data => {
      if (data) {
        this.customizedAttributes = data;
        if (this.customizedAttributes?.competitionSignUp?.requireMandatory !== undefined) {
          const requireMandatory = this.customizedAttributes?.competitionSignUp?.requireMandatory;
          if (requireMandatory) {
            this.requireMandatory = requireMandatory;
          }
        }
      }
      console.debug('get customized attributes : ', data, this.customizedAttributes);
    });
  }
  // ionViewWillEnter() {
  //   this.backButtonSub = this.platform.backButton.subscribeWithPriority(9999, () => {
  //     this.modalCtrl.dismiss();
  //   });
  // }

  ionViewWillLeave() {
    // Unsubscribe from all pending requests to prevent memory leaks
    this.updateSubscriptions.forEach(sub => sub.unsubscribe());
    this.updateSubscriptions = [];
    this.cleanupUploadedFiles();
  }

  ionViewDidEnter() {
    // Scroll to section specified by jumpTo input when modal opens
    if (this.jumpTo) {
      console.log('JumpTo section:', this.jumpTo);
      // Use setTimeout to ensure modal content is fully rendered before scrolling
      setTimeout(() => {
        this.scrollToSection(this.jumpTo);
      }, 500);
    }
  }

  private scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      console.log(`Scrolled to section: ${sectionId}`);

      // Apply heartbeat animation to the userProfile div within the scrolled section
      setTimeout(() => {
        const userProfileDiv = element.querySelector('.userProfile');
        console.log('Found userProfile div:', userProfileDiv);

        if (userProfileDiv) {
          // Force a reflow to ensure the animation triggers
          userProfileDiv.classList.remove('heartbeat-highlight');
          void (userProfileDiv as HTMLElement).offsetWidth; // Trigger reflow
          userProfileDiv.classList.add('heartbeat-highlight');
          console.log('Applied heartbeat-highlight class to userProfile');

          // Remove the animation class after 2 seconds (animation duration)
          setTimeout(() => {
            userProfileDiv.classList.remove('heartbeat-highlight');
            console.log('Removed heartbeat-highlight class from userProfile');
          }, 5000);
        } else {
          console.warn('Could not find .userProfile div in section:', sectionId);
        }
      }, 300); // Small delay to ensure scrolling has started
    } else {
      console.warn(`Section not found: ${sectionId}`);
    }
  }
  getDateTimeDisplayFormat(field) {
    if (!field) {
      return 'YYYY-MM-DD HH:mm';
    }
    if (field?.type === 'time') {
      return 'HH:mm';
    } else if (field?.type === 'date') {
      return 'YYYY-MM-DD';
    } else if (field?.type === 'datetime') {
      return 'YYYY-MM-DD HH:mm';
    }
  }
  getDateTimePickerFormat(field) {
    if (!field) {
      return 'YYYY-MM-DD HH:mm';
    }
    if (field?.type === 'time') {
      return 'HH:mm';
    } else if (field?.type === 'date') {
      return 'YYYY-MM-DD';
    } else if (field?.type === 'datetime') {
      return 'YYYY-MM-DD HH:mm';
    }
  }
  getDateTimeValueFormat(field) {
    if (!field) {
      return 'YYYY-MM-DD HH:mm';
    }
    if (field?.type === 'time') {
      return 'HH:mm';
    } else if (field?.type === 'date') {
      return 'YYYY-MM-DD';
    } else if (field?.type === 'datetime') {
      return 'YYYY-MM-DD HH:mm';
    }
  }

  compAddlInfoForm: any;
  constructDynamicForms(data: any) {
    const groupedData = [];
    let currentGroup = null;

    // Create a default group for fields before the first separator
    currentGroup = {
      name: 'additionalInfo',
      display: data.title,
      description: '',
      fields: [],
    };
    groupedData.push(currentGroup);

    let hcpUploadIndex = 0;
    data.fields.forEach(async field => {
      if (field.type === 'separator') {
        currentGroup = {
          name: field.name,
          display: field.properties.sectionTitle,
          description: field.properties.sectionDescription,
          fields: [],
        };
        groupedData.push(currentGroup);
      } else {
        if (field?.hint) {
          field.hint = this.parseTextWithLinks(field.hint);
        }
        if (field?.tooltip) {
          field.tooltip = this.parseTextWithLinks(field.tooltip);
        }

        console.debug('construct fields : ', field, currentGroup, this.countryList);
        if (field?.type === 'options' && field?.optionSource?.options === undefined) {
          if (field?.optionSource?.type === 'Country') {
            if (field?.optionSource?.options === undefined) field.optionSource.options = [];
            try {
              this.getCountryList().then((result: any) => {
                // console.debug('construct fields [country] : ', result);
                if (result?.countryList?.length) {
                  result?.countryList?.forEach((country: CountryData) => {
                    field.optionSource.options.push({
                      label: country?.name,
                      value: country?.id,
                    });
                  });
                }
              });
            } catch {}
          }
        }
        if (currentGroup?.name === 'handicapUpload' && field?.type === 'file') {
          if (field?.hcpUploadIndex === undefined) {
            field.hcpUploadIndex = hcpUploadIndex;
          } else field.hcpUploadIndex = hcpUploadIndex;
          if (hcpUploadIndex === 0) {
            this.showAdditionalHcpUpload[0] = true;
            this.showAddHcpUpload.push({
              idx: hcpUploadIndex,
              name: field.name,
              show: true,
            });
            // this.showAdditionalHcpUpload.push(true);
          } else {
            this.showAdditionalHcpUpload[hcpUploadIndex] = false;
            this.showAddHcpUpload.push({
              idx: hcpUploadIndex,
              name: field.name,
              show: false,
            });
            // this.showAdditionalHcpUpload.push(false);
          }

          hcpUploadIndex++;
        }
        console.debug('construct : ', this.showAdditionalHcpUpload);
        // This handles the case where the first fields are not under a separator
        if (currentGroup) {
          currentGroup.fields.push(field);
        }
      }
    });

    return groupedData;
  }

  temporaryImageURL: any = {};

  async multiplePhotoFromGallery(event, whichFile: string) {
    const files: FileList = event.target.files;

    const fileArray: File[] = Array.from(files);
    console.debug('multiple photo : ', event, files, fileArray);

    // Clear previous URLs to prevent memory leaks

    this.cleanupUploadedFiles(whichFile);
    let _uploadedFiles = [];
    switch (whichFile) {
      case 'passport':
        _uploadedFiles = this.uploadedPassportFiles;
        break;
      case 'insurance':
        _uploadedFiles = this.uploadedInsuranceFiles;
        break;
    }
    if (!_uploadedFiles?.length) {
      this.cleanupUploadedFiles(whichFile);
    }
    let fileIsBig: boolean = false;
    fileArray.forEach(file => {
      if (file.type.startsWith('image/') || file.type.startsWith('pdf')) {
        const previewUrl = URL.createObjectURL(file);
        const safeUrl = this.sanitizer.bypassSecurityTrustUrl(previewUrl);
        const sizeInMB = file.size / (1024 * 1024);
        _uploadedFiles.push({
          url: safeUrl,
          file: file,
          name: file.name,
          size: file.size,
          sizeInMB: sizeInMB,
        });
        if (sizeInMB >= 1) {
          fileIsBig = true;
        }
      } else {
        console.warn('Skipping non-image file:', file.name);
      }
    });

    if (fileIsBig) {
      MessageDisplayUtil.showErrorToast(
        "Filesize more than 1 MB won't be uploaded",
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
    }

    console.log('multiple photo [1]: ', fileArray);
    // upload loop or batch upload
  }
  cleanupUploadedFiles(whichFile?: string) {
    if (!whichFile) {
      this.uploadedPassportFiles.forEach(item => {
        if (item.url) {
          const urlString = item.url.toString();
          URL.revokeObjectURL(urlString);
        }
      });
      this.uploadedPassportFiles = [];
      this.uploadedInsuranceFiles.forEach(item => {
        if (item.url) {
          const urlString = item.url.toString();
          URL.revokeObjectURL(urlString);
        }
      });
      this.uploadedInsuranceFiles = [];
    }
    // Revoke all previous object URLs to free memory
    let _uploadedFiles = [];
    switch (whichFile) {
      case 'passport':
        _uploadedFiles = this.uploadedPassportFiles;
        break;
      case 'insurance':
        _uploadedFiles = this.uploadedInsuranceFiles;
        break;
    }

    _uploadedFiles.forEach(item => {
      if (item.url) {
        const urlString = item.url.toString();
        URL.revokeObjectURL(urlString);
      }
    });
    _uploadedFiles = [];
  }

  // Add these helper methods:
  uploadedPassportFiles: Array<{
    url: SafeUrl;
    file: File;
    name: string;
    size: number;
    sizeInMB: number;
  }> = [];
  uploadedInsuranceFiles: Array<{
    url: SafeUrl;
    file: File;
    name: string;
    size: number;
    sizeInMB: number;
  }> = [];

  // async uploadFiles(files: File[]) {
  //   const formData = new FormData();

  //   files.forEach(file => {
  //     formData.append('files', file); // backend must support array
  //   });

  //   console.debug('uploading files : ', formData);

  //   // return this.http.post('YOUR_API_URL', formData).toPromise();
  // }

  onClickRemoveNewFiles(idx: number, whichFile?: string) {
    if (idx === undefined) {
      this.uploadedPassportFiles = [];
    } else {
      this.uploadedPassportFiles.splice(idx, 1);
    }

    // delete this.uploadedFiles[idx];
  }
  async onClickRemoveFile(documentUrl: string) {
    const _header = 'Remove Handicap Document';
    let _msg = 'Do you want to remove this Handicap Document?';
    const _subMsg = '';
    const modal = await this.modalCtl.create({
      component: CommonPullupMenuComponent, // DeleteRoomModalComponent,
      // showBackdrop:true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        mode: 'negative-confirmation',
        headerTitle: _header,
        confirmMessage: _msg,
      },
    });
    await modal.present();
    modal.onDidDismiss().then(data => {
      if (data) {
        if (data?.data) {
          this.goProcessRemoveFile(documentUrl);
        }
      }
    });
  }

  goProcessRemoveFile(documentUrl: string) {
    const orgId: number = this.leagueSeason?.league?.organizer?.id || 0;
    const multiCompId: number = this.leagueSeason?.id || 0;
    const playerId = this.player?.playerId || this.player?.id;
    this.flightService
      .deleteMCTHandicapDocument(orgId, multiCompId, playerId, documentUrl)
      .subscribe(data => {
        if (data) {
          this.rosterDetails = data;

          this.multiCourseCompService.setRefreshMCTDetails(true);
        }
        MessageDisplayUtil.showMessageToast(
          'Successfully removed document',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
      });
    // delete this.uploadedFiles[idx];
  }

  async takePhotoFromGallery(event, field) {
    // if (event) {
    //   const fileObject = event.target.files[0];
    // }

    // this.selectedFiles = event.target.files[0];
    this.playerForm[field.name] = event.target.files[0];
    // const file = (event.target as HTMLInputElement).files;
    //

    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      const images = [];
      for (let i = 0; i < filesAmount; i++) {
        const reader = new FileReader();
        // eslint-disable-next-line @typescript-eslint/no-shadow
        reader.onload = (event: any) => {
          // Push Base64 string
          images.push(event.target.result);
        };
        reader.readAsDataURL(event.target.files[i]);
      }
      console.debug('take photo from gallery : ', filesAmount, images, event);
      this.temporaryImageURL[field.name] = event.target.files[0].name;
      const _tmpFile = event.target.files[0];
      // this.previewImage = images;

      // if (this.selectedFiles && mode === 'update')
      //   this._uploadImage(this.temporaryImageURL);

      let preview = document.getElementById(`preview-${field.name}`) as HTMLImageElement;
      this.tmpFilename[field.name] = _tmpFile?.name;
      if (_tmpFile.type.startsWith('image/')) {
        // ✅ It's an image — show preview
        preview.src = URL.createObjectURL(_tmpFile);
        preview.style.display = 'block';
        preview.onload = () => URL.revokeObjectURL(preview.src);
      } else {
        // ❌ Not an image — show a placeholder icon based on file type
        preview.style.display = 'block';
        preview.onload = null;

        if (_tmpFile.type === 'application/pdf') {
          preview.src = 'assets/icons/pdf-file.png';
        } else if (_tmpFile.type.startsWith('video/')) {
          preview.src = 'assets/icons/video-file.png';
        } else if (_tmpFile.type.includes('word') || _tmpFile.type.includes('document')) {
          preview.src = 'assets/icons/doc-file.png';
        } else {
          preview.src = 'assets/icons/file-icon.png'; // generic fallback
        }
      }
      // preview.src = URL.createObjectURL(_tmpImage); // 👈 creates a blob: URL
      // preview.style.display = 'block';

      // // ⚠️ Important: revoke the object URL after use to free memory
      // preview.onload = () => URL.revokeObjectURL(preview.src);
    }
  }
  tmpFilename: any = {};
  deleteImage(field) {
    this.temporaryImageURL[field.name] = null;
    // if(this.playerDiscountProgram?.document){
    //    this.playerDiscountProgram.document = null;
    // }
  }
  onProceedPlayerUpdates() {
    console.debug('proceed player updates [0] ', this.player);
    console.debug('proceed player updates [1]', this.playerForm);
    console.debug('proceed player updates [2]', this.appAttribute);

    if (!this.appAttribute) {
      return;
    }

    const competitionSignUp = this.appAttribute.find(
      att => att.page === 'competition'
    )?.competitionSignUp;

    if (!competitionSignUp?.updatePlayerMapping) {
      return;
    }

    // Use spread operator for cleaner shallow copy
    const playerMapping = { ...competitionSignUp.updatePlayerMapping };

    // Build fields to update using Object.entries for proper object iteration
    const fieldsToUpdate: Record<string, any> = {};

    for (const [key, _] of Object.entries(playerMapping)) {
      if (this.playerForm[key] !== undefined) {
        // Removed unnecessary await - this is synchronous
        fieldsToUpdate[playerMapping[key]] = this.playerForm[key];
      }
    }
    this.goProcessPlayerUpdate(fieldsToUpdate, playerMapping);

    // get plyer home info
    // (this.playerHomeActions
    //   .updatePlayerProfile(this.player, friend)
    //   .subscribe((result: boolean) => {
    // })
  }
  async onProceedCompUpdates() {
    if (!this.appAttribute) {
      return;
    }

    const competitionSignUp = this.appAttribute.find(
      att => att.page === 'competition'
    )?.competitionSignUp;

    if (!competitionSignUp?.updateCompPlayerMapping) {
      return;
    }

    // Use spread operator for cleaner shallow copy
    const compMapping = { ...competitionSignUp.updateCompPlayerMapping };

    // Build fields to update using Object.entries for proper object iteration
    const fieldsToUpdate: Record<string, any> = {};

    for (const [key, _] of Object.entries(compMapping)) {
      if (this.playerForm[key] !== undefined) {
        // Removed unnecessary await - this is synchronous
        fieldsToUpdate[key] = this.playerForm[key];
      }
    }

    // Check if there are actually fields to update
    if (Object.keys(fieldsToUpdate).length === 0) {
      console.debug('No fields to update for competition player');
      return;
    }

    this.goProcessCompUpdate(fieldsToUpdate, compMapping);
  }

  goProcessCompUpdate(fieldsToUpdate: Record<string, any>, compMapping: Record<string, string>) {
    const compId = this.compData?.id;
    const playerId = this.player?.playerId || this.player?.id;

    if (!compId || !playerId) {
      console.error('Missing compId or playerId for update');
      return;
    }

    const playerIds = [playerId];
    const updateRequests: Array<Observable<any>> = [];

    // Collect all update requests
    for (const [key, updateType] of Object.entries(compMapping)) {
      const value = fieldsToUpdate[key];
      if (value === undefined) {
        continue;
      }

      switch (updateType) {
        case 'updateShirtSize':
          updateRequests.push(
            this.flightService.updateCompPlayerShirtSize(compId, playerIds, value)
          );
          break;
        case 'updateHandicapIndex':
          updateRequests.push(
            this.flightService.updateCompPlayerHandicapIndex(compId, playerId, Number(value))
          );
          break;
        default:
          console.warn(`Unknown update type: ${updateType}`);
      }
    }

    if (updateRequests.length === 0) {
      console.debug('No valid update requests to execute');
      return;
    }

    // Execute all updates in parallel using forkJoin
    const subscription = forkJoin(updateRequests)
      .pipe(
        catchError(error => {
          console.error('Error updating competition player:', error);
          MessageDisplayUtil.showErrorToast(
            error.status || 'UPDATE_FAILED',
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
          return of(null); // Return observable to prevent error propagation
        })
      )
      .subscribe({
        next: results => {
          console.debug('Competition player updates completed:', results);
        },
        complete: () => {
          // Cleanup handled by ionViewWillLeave
        },
      });

    this.updateSubscriptions.push(subscription);
  }

  goProcessPlayerUpdate(
    fieldsToUpdate: Record<string, any>,
    playerMapping: Record<string, string>
  ) {
    const playerId = this.player?.playerId || this.player?.id;
    console.debug('proceed player updates [3]', fieldsToUpdate);
    if (!playerId) {
      console.error('Missing playerId for update');
      return;
    }
    let _params = this.player;

    for (const [key, value] of Object.entries(fieldsToUpdate)) {
      // const value = fieldsToUpdate[playerMapping[key]];
      if (value === undefined) {
        continue;
      }
      _params[key] = value;
    }

    this.flightService.updatePlayerProfile(playerId, _params).subscribe(data => {
      console.debug('done update player profile ', this.playerForm, this.player, _params, data);
    });
  }

  getPlayerDetails() {
    const playerId = this.player?.playerId || this.player?.id;
    this.flightService.getPlayerDetails(playerId).subscribe(playerDetails => {
      this.player = playerDetails;
    });
  }
  onKeyupEvent(event, field) {
    this.playerForm[field.name] = this.playerForm[field.name].toUpperCase();
  }

  onClickViewFile(filename: string) {
    const url = `${globals.MygolfServer}/${filename}`;
    Browser.open({ url: url });
  }

  getFilename(filename: string, fieldName?: string) {
    // const _filename = filename.split('/')[6].split('?')[0];
    const _filename = fieldName;
    return _filename;
  }
  isFileImage(filename: string) {
    return (
      filename?.toLowerCase()?.includes('.png') ||
      filename?.toLowerCase()?.includes('.jpeg') ||
      filename?.toLowerCase()?.includes('.jpg')
    );
  }
  isFilePdf(filename: string) {
    return filename?.toLowerCase()?.includes('.pdf');
  }
  isAllowedForm(formName: string) {
    if (!this.allowedForms) {
      return true;
    }
    if (!this.allowedForms?.length) {
      return true;
    }
    return this.allowedForms?.find(form => form === formName);
  }

  countryList: Array<CountryData> = [];
  getCountryList() {
    return new Promise((resolve, reject) => {
      this.flightService.getCountryList().subscribe(countryList => {
        console.debug('get country list : ', countryList);
        if (countryList?.length) {
          this.countryList = countryList;
          resolve({ countryList });
        }
      });
    });
  }

  showAdditionalHcpUpload: Array<any> = [];
  showAddHcpUpload: Array<any> = [];
  // [
  //   { idx: 0, show: true },
  //   { idx: 1, show: false },
  //   { idx: 2, show: false },
  //   { idx: 3, show: false },
  //   { idx: 4, show: false },
  // ];
  onToggleShowAddHcpUpload(idx: number, name?: string) {
    this.showAdditionalHcpUpload[idx] = true;
    this.showAddHcpUpload
      .find(hcpUpload => {
        return hcpUpload.name === name;
      })
      .map(hcpUpload => (hcpUpload.show = true));
  }
  onToggleHideAddHcpUpload(idx: number, name?: string) {
    this.showAdditionalHcpUpload[idx] = false;
    this.showAddHcpUpload
      .find(hcpUpload => {
        return hcpUpload.name === name;
      })
      .map(hcpUpload => (hcpUpload.show = false));
  }

  getHandicapDocumentImage(url?: string) {
    if (url?.toLowerCase()?.includes(globals.MygolfServerHost?.toLowerCase())) return url;
    else return globals.MygolfServer + '/' + url;
  }
  getHandicapDocumentFilename(url?: string) {
    if (!url) return '';
    const fileSplitLength = url?.split('/')?.length || 0;
    const filename = url?.split('/')[fileSplitLength - 1];
    // console.debug('get hcp doc name : ', url, fileSplitLength, url?.split('/'), filename);
    return filename;
  }

  parseDocumentFilename(url?: string) {
    if (!url) return '';
    const fileSplitLength = url?.split('/')?.length || 0;
    const filename = url?.split('/')[fileSplitLength - 1].split('?')[0];
    // console.debug('get hcp doc name : ', url, fileSplitLength, url?.split('/'), filename);
    return filename;
  }

  async onClickImageZoom(documentUrl: string) {
    const modal: any = await this.modalCtl.create({
      component: ImageZoomPage,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        image: documentUrl,
      },
    });
    await modal.present();
  }

  hasFilesizeBig() {
    return (
      this.uploadedPassportFiles?.filter(uf => {
        return uf?.sizeInMB > 1;
      })?.length > 0
    );
  }

  onToggleEditMode() {
    this.viewMode = !this.viewMode;
  }

  // playerTravelForm: MCTPlayerTravelInfoForm;
  inputPlayerTravelForm: MCTPlayerTravelInfoForm;
  async openDateModal(whichDate?: string) {
    const calendarOptions: CalendarComponentOptions = {
      from: moment('2026-06-13', 'YYYY-MM-DD').toDate(),
      // from: this.startDate ? moment(this.startDate).startOf('day').toDate() : new Date(),
      to: moment('2026-06-20', 'YYYY-MM-DD').toDate(),
      pickMode: 'single',
    };
    let _selectedDate = '';
    if (whichDate === 'arrival') {
      _selectedDate = this.inputPlayerTravelForm.arrivalDate; // = moment().format('YYYY-MM-DD');
    } else if (whichDate === 'departure') {
      _selectedDate = this.inputPlayerTravelForm.departureDate; // = moment().format('YYYY-MM-DD');
    } else if (whichDate === 'passportExpiry') {
      _selectedDate = this.inputPlayerTravelForm.passportExpiry; // = moment().format('YYYY-MM-DD');
    }
    const modal = await this.modalCtl.create({
      component: DateRangePicker,
      componentProps: {
        selectedDate: _selectedDate,
        optionsRange: calendarOptions,
      },
    });

    await modal.present();

    modal.onDidDismiss().then(data => {
      console.debug('date modal dismiss : ', data);
      if (data.data) {
        if (whichDate === 'arrival') {
          this.inputPlayerTravelForm.arrivalDate = moment(data.data?.selectedDate).format(
            'YYYY-MM-DD'
          );
        } else if (whichDate === 'departure') {
          this.inputPlayerTravelForm.departureDate = moment(data.data?.selectedDate).format(
            'YYYY-MM-DD'
          );
        } else if (whichDate === 'passportExpiry') {
          this.inputPlayerTravelForm.passportExpiry = moment(data.data?.selectedDate).format(
            'YYYY-MM-DD'
          );
        }
      }
    });
  }

  validTime(event) {
    console.debug(
      'time : ',
      event,
      event?.target?.value,
      this.arrivalTime,
      moment(this.arrivalTime, 'HH:mm').format('HH:mm:ss'),
      this.departureTime
    );
  }
  fromTime: any = moment().format('HH:mm');
  toTime: any = moment().format('HH:mm');

  hotelsList: Array<any>;
  selectedHotel: any;
  refreshHotelList() {
    return new Promise((resolve, reject) => {
      let _multiCourseCompId = this.leagueSeason?.id;
      this.flightService.getMCTHotelList(_multiCourseCompId, null, true).subscribe(
        hotels => {
          this.hotelsList = hotels;
          resolve(hotels);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  hotelRooms: Array<any>;
  selectedHotelRoom: any;
  getHotelDetails(compHotelId?: number) {
    let _multiCourseCompId = this.leagueSeason?.id;
    if (compHotelId) compHotelId = compHotelId;
    else compHotelId = this.selectedHotel?.id;
    this.flightService
      .getMCTHotelDetails(_multiCourseCompId, compHotelId)
      .subscribe((hotelDetails: any) => {
        if (hotelDetails?.hotelRooms) this.hotelRooms = hotelDetails?.hotelRooms;
      });
  }

  onNewClickHotelList() {
    return new Promise(async (resolve, reject) => {
      if (this.viewMode) {
        reject(false);
        return;
      }
      if (this.lockStayDetails) {
        MessageDisplayUtil.showErrorToast(
          this.msgLockStayDetails,
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        reject(false);
        return;
      }
      if (this.playerTravelInfo?.roomNumber !== undefined && this.playerTravelInfo?.roomNumber) {
        MessageDisplayUtil.showErrorToast(
          'Please contact organizer as room has been allocated.',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        reject(false);
        return;
      }
      const _dataList = [];
      let _hotels = [];
      try {
        // _hotels = await
        await this.refreshHotelList().then((result: Array<any>) => {
          if (result) {
            console.debug('going into hotel list [0] : ', result);
            _hotels = result;
          }
          // return result;
        });
      } catch (error) {
      } finally {
        console.debug('going into hotel list [1] : ', _hotels);
        if (_hotels.length > 0) {
          _hotels.forEach(hotel => {
            const hotelAddress = hotel?.hotel?.address?.city
              ? `(${hotel?.hotel?.address?.city}, ${hotel?.hotel?.address?.state})`
              : '';
            _dataList.push({
              id: hotel.id,
              name: `${hotel?.hotel?.name} ${hotelAddress}`,
              iconUrl: hotel?.hotel?.hotelLogo,
              data: hotel,
            });
          });

          const modal = await this.modalCtl.create({
            mode: 'ios',
            component: HotelListPage,
            cssClass: 'self-adjustable-modal',
            componentProps: {
              app: null,
              dataList: _dataList,
              hotelList: _hotels,
              mode: 'common',
              headerTitle: 'Hotel List',
            },
          });
          await modal.present().then(() => {
            const height = this.platform.height() - 250;
            if (document.getElementsByClassName('inner-content')[0])
              document.getElementsByClassName('inner-content')[0]['style'].maxHeight =
                `${height}px`;
          });
          modal.onDidDismiss().then((data: any) => {
            console.debug('pullup dismiss - hotel', data);
            if (data) {
              if (data?.data?.id) {
                this.selectedHotel = data?.data;
                this.inputPlayerTravelForm.tournamentHotelId = data?.data?.id;
                this.getHotelDetails(data?.data?.id);
                resolve(true);
              }
            }
            // if(data)
          });
        }
      }
    });
  }

  async onClickHotelList() {
    return new Promise(async (resolve, reject) => {
      if (this.viewMode) {
        reject(false);
        return;
      }
      if (this.lockStayDetails) {
        MessageDisplayUtil.showErrorToast(
          this.msgLockStayDetails,
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        reject(false);
        return;
      }
      if (this.playerTravelInfo?.roomNumber !== undefined && this.playerTravelInfo?.roomNumber) {
        MessageDisplayUtil.showErrorToast(
          'Please contact organizer as room has been allocated.',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        reject(false);
        return;
      }
      const _dataList = [];
      let _hotels = [];
      try {
        _hotels = await this.refreshHotelList().then((result: Array<any>) => {
          return result;
        });
      } catch (error) {
      } finally {
        if (_hotels.length > 0) {
          _hotels.forEach(hotel => {
            const hotelAddress = hotel?.hotel?.address?.city
              ? `(${hotel?.hotel?.address?.city}, ${hotel?.hotel?.address?.state})`
              : '';
            _dataList.push({
              id: hotel.id,
              name: `${hotel?.hotel?.name} ${hotelAddress}`,
              iconUrl: hotel?.hotel?.hotelLogo,
              data: hotel,
            });
          });

          const modal = await this.modalCtl.create({
            mode: 'ios',
            component: CommonPullupMenuComponent,
            cssClass: 'self-adjustable-modal',
            componentProps: {
              app: null,
              dataList: _dataList,
              mode: 'common',
              headerTitle: 'Staying At',
            },
          });
          await modal.present().then(() => {
            const height = this.platform.height() - 250;
            document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
          });
          modal.onDidDismiss().then((data: any) => {
            console.debug('pullup dismiss - hotel', data);
            if (data) {
              if (data?.data?.id) {
                this.selectedHotel = data?.data;
                this.inputPlayerTravelForm.tournamentHotelId = data?.data?.id;
                this.getHotelDetails(data?.data?.id);
                resolve(true);
              }
            }
            // if(data)
          });
        }
      }
    });
  }

  async onClickHotelRooms() {
    return new Promise(async (resolve, reject) => {
      if (this.viewMode) {
        reject(false);
        return;
      }
      if (this.lockStayDetails) {
        MessageDisplayUtil.showErrorToast(
          this.msgLockStayDetails,
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        reject(false);
        return;
      }
      if (!this.selectedHotel) {
        // this.onClickHotelList().then((result: boolean) => {
        //   console.debug('on click hotel list : ', this.selectedHotel, result);
        //   if (result && this.hotelRooms?.length) {
        //     this.onClickHotelRooms();
        //     console.debug('on click hotel rooms : ', this.hotelRooms);
        //   }
        // });
        MessageDisplayUtil.showErrorToast(
          'Please select a Hotel first',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return;
      }
      if (this.playerTravelInfo?.roomNumber !== undefined && this.playerTravelInfo?.roomNumber) {
        MessageDisplayUtil.showErrorToast(
          'Please contact organizer as room has been allocated.',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        reject(false);
        return;
      }
      const _dataList = [];
      let _hotelRooms = this.hotelRooms;
      try {
        if (!this.hotelRooms?.length) {
          this.getHotelDetails(this.selectedHotel?.id);
          _hotelRooms = this.hotelRooms;
        }
        // _hotelRooms = await this.refreshHotelList().then((result: Array<any>) => {
        //   return result;
        // });
      } catch (error) {
      } finally {
        if (_hotelRooms?.length > 0) {
          _hotelRooms.forEach(room => {
            // const hotelAddress = hotel?.hotel?.address?.city
            //   ? `(${hotel?.hotel?.address?.city}, ${hotel?.hotel?.address?.state})`
            //   : '';
            let hotelInfo = `${room?.hotelRoom?.roomName} - Max ${room?.maxOccupancy}`;
            const isRoomUpgrade = room?.upgrade ? '(Upgrade)' : '';
            hotelInfo += ` ${isRoomUpgrade}`;
            _dataList.push({
              id: room?.id,
              name: hotelInfo,
              data: room,
            });
          });

          const modal = await this.modalCtl.create({
            mode: 'ios',
            component: CommonPullupMenuComponent,
            cssClass: 'self-adjustable-modal',
            componentProps: {
              app: null,
              dataList: _dataList,
              mode: 'common',
              headerTitle: 'Staying At',
            },
          });
          await modal.present().then(() => {
            const height = this.platform.height() - 250;
            document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
          });
          modal.onDidDismiss().then((data: any) => {
            console.debug('pullup dismiss - room', data);
            if (data) {
              if (data?.data?.id) {
                this.selectedHotelRoom = data?.data;
                this.inputPlayerTravelForm.tournamentHotelRoomId = data?.data?.id;
                this.getHotelRoomAllocations(data?.data);
                resolve(true);
              }
            }
            // if(data)
          });
        }
      }
    });
  }

  participantsList: Array<LeagueSeasonParticipantView> = [];
  selectedSharingRoomWith: Array<{ id: number; name: string }> = [];

  async onClickSharingRoomWith() {
    if (this.viewMode) {
      return;
    }
    if (this.lockStayDetails) {
      MessageDisplayUtil.showErrorToast(
        this.msgLockStayDetails,
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    }
    console.debug('selected hotel and room ', this.selectedHotel, this.selectedHotelRoom);
    if (!this.leagueSeason) {
      MessageDisplayUtil.showErrorToast(
        `There seems to be no options to choose. Please contact Admin`,
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    }
    if (!this.selectedHotel) {
      MessageDisplayUtil.showErrorToast(
        `Please select a Hotel and a Room Type`,
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    }
    if (
      this.selectedHotelRoom?.data?.maxOccupancy <= 1 ||
      !this.selectedHotelRoom?.data?.allowSharing
    ) {
      MessageDisplayUtil.showErrorToast(
        `Not allowed sharing`,
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    }
    if (this.playerTravelInfo?.roomNumber !== undefined && this.playerTravelInfo?.roomNumber) {
      MessageDisplayUtil.showErrorToast(
        'Please contact organizer as room has been allocated.',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
    }
    const _dataList = [];
    let _currentPlayer = this.rosterDetails?.player;
    let _playersAllocated = [];
    this.mctRoomAllocations?.forEach(roomAlloc => {
      _playersAllocated.push(...roomAlloc?.playerIds);
    });

    console.debug(
      'on click sharing room with : ',
      this.rosterDetails,
      this.participantsList,
      this.mctRoomAllocations,
      _playersAllocated
    );
    let _participantsList = this.participantsList
      ?.sort((a, b) => {
        if (a?.player?.playerName < b?.player?.playerName) return -1;
        else if (a?.player?.playerName > b?.player?.playerName) return 1;
        else return 0;
      })
      .filter(ptcpt => {
        return (
          ptcpt?.player?.id !== _currentPlayer?.id &&
          !_playersAllocated?.includes(ptcpt?.player?.id) &&
          ptcpt?.participatingClub?.id === this.rosterDetails?.participatingClub?.id
        );
      });
    // if(this.participantsList?.length) {
    //   this.participantsList?.forEach((participant: LeagueSeasonParticipantView)=>{
    //     _dataList.push({
    //       id: participant?.player?.id,
    //       name: participant?.player?.playerName,
    //     })
    //   })
    // }
    console.debug('on click sharing room with [1]: ', _participantsList);
    try {
    } catch (error) {
    } finally {
      if (_participantsList.length > 0) {
        _participantsList.forEach(participant => {
          _dataList.push({
            id: participant?.player?.id,
            name: `${participant?.player?.playerName} - ${participant?.participationType}`,
            data: participant,
          });
        });

        const maxSelection =
          this.selectedHotelRoom?.data?.maxOccupancy > 1
            ? this.selectedHotelRoom?.data?.maxOccupancy - 1
            : 0;

        const _headerTitle = 'Select Sharing Room With';
        const modal = await this.modalCtl.create({
          mode: 'ios',
          component: CommonPullupMenuComponent,
          cssClass: 'self-adjustable-modal',
          componentProps: {
            app: null,
            dataList: _dataList,
            mode: 'common',
            headerTitle: _headerTitle,
            multipleSelection: true,
            maxSelection: maxSelection,
            showSearchbar: true,
            scrollable: true,
            selectedMultiValues: this.inputPlayerTravelForm?.sharingRoomWith,
          },
        });
        await modal.present().then(() => {
          const height = this.platform.height() - 250;
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        });
        modal.onDidDismiss().then((data: any) => {
          console.debug('pullup dismiss - room', data);
          if (data) {
            if (data?.data?.length) {
              this.inputPlayerTravelForm.sharingRoomWith = data?.data.map(p => {
                return p?.id;
              });
              this.selectedSharingRoomWith = data?.data;
            }
          }
          console.debug(
            'pullup dismiss - sharingRoom [1] ',
            this.selectedSharingRoomWith,
            this.inputPlayerTravelForm.sharingRoomWith
          );
          // if(data)
        });
      } else {
        MessageDisplayUtil.showErrorToast(
          'Please contact Organizer as there is no participants to choose from',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
      }
    }
  }

  async onClickAirport(arrivalDeparture?: string) {
    if (this.viewMode) {
      return;
    }
    if (!this.leagueSettings) {
      MessageDisplayUtil.showErrorToast(
        `There seems to be no options to choose. Please contact Admin`,
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
    }
    let _airports = this.leagueSettings?.airports?.map(airport =>
      airport.replace(/[\r\n\t]/g, ' ').trim()
    );
    if (!_airports?.length) {
      MessageDisplayUtil.showErrorToast(
        `There seems to be no options to choose. Please contact Admin`,
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
    }
    const _dataList = [];
    try {
    } catch (error) {
    } finally {
      if (_airports.length > 0) {
        _airports.forEach(airport => {
          _dataList.push({
            id: airport,
            name: airport,
          });
        });

        const _headerTitle =
          arrivalDeparture === 'arrival' ? `Arrival Airport` : `Departure Airport`;
        const modal = await this.modalCtl.create({
          mode: 'ios',
          component: CommonPullupMenuComponent,
          cssClass: 'self-adjustable-modal',
          componentProps: {
            app: null,
            dataList: _dataList,
            mode: 'common',
            headerTitle: _headerTitle,
          },
        });
        await modal.present().then(() => {
          const height = this.platform.height() - 250;
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        });
        modal.onDidDismiss().then((data: any) => {
          console.debug('pullup dismiss - room', data);
          if (data) {
            if (data?.data?.id) {
              if (arrivalDeparture === 'arrival') {
                this.inputPlayerTravelForm.arrivingAirport = data?.data?.id;
              } else {
                this.inputPlayerTravelForm.departingAirport = data?.data?.id;
              }
              // this.selectedHotelRoom = data?.data;
              // this.inputPlayerTravelForm.foodPreference = data?.data?.id;
            }
          }
          // if(data)
        });
      }
    }
  }

  async onClickFoodPreferences() {
    if (this.viewMode) {
      return;
    }
    if (!this.leagueSettings) {
      MessageDisplayUtil.showErrorToast(
        `There seems to be no options to choose. Please contact Admin`,
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
    }
    let _foodPreferences = this.leagueSettings?.foodPreferences?.map(foodPref =>
      foodPref.replace(/[\r\n\t]/g, ' ').trim()
    );
    if (!_foodPreferences?.length) {
      MessageDisplayUtil.showErrorToast(
        `There seems to be no options to choose. Please contact Admin`,
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
    }
    const _dataList = [];
    try {
    } catch (error) {
    } finally {
      if (_foodPreferences.length > 0) {
        _foodPreferences.forEach(foodPref => {
          _dataList.push({
            id: foodPref,
            name: foodPref,
          });
        });

        const modal = await this.modalCtl.create({
          mode: 'ios',
          component: CommonPullupMenuComponent,
          cssClass: 'self-adjustable-modal',
          componentProps: {
            app: null,
            dataList: _dataList,
            mode: 'common',
            headerTitle: 'Food Preferences',
            subTitle: 'Select one or more',
            multipleSelection: true,
            selectedMultiValues: this.inputPlayerTravelForm?.foodPreference,
          },
        });
        await modal.present().then(() => {
          const height = this.platform.height() - 250;
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        });
        modal.onDidDismiss().then((data: any) => {
          console.debug('pullup dismiss - room', data);
          if (data) {
            if (data?.data?.length) {
              this.inputPlayerTravelForm.foodPreference = data?.data?.map(foodPref => foodPref?.id);
              console.debug(
                'dismiss - food ',
                this.inputPlayerTravelForm.foodPreference,
                data?.data?.map(foodPref => {
                  return foodPref?.id;
                })
              );
              // this.selectedHotelRoom = data?.data;
              // this.inputPlayerTravelForm.foodPreference = data?.data?.id;
            }
          }
          // if(data)
        });
      }
    }
  }

  getInputTravelDetails(attribute: 'foodPreferences' | 'sharingRoomWith') {
    switch (attribute) {
      case 'foodPreferences':
        console.debug(
          'input travel details : ',
          attribute,
          this.inputPlayerTravelForm?.foodPreference?.join(', ')
        );
        return this.inputPlayerTravelForm?.foodPreference?.join(', ');
      case 'sharingRoomWith':
        return (
          this.selectedSharingRoomWith?.map(participant => participant?.name).join(', ') ||
          'Select Sharing Room With'
        );
    }
  }

  onClickRemoveFoodPref(foodPref?: string) {
    console.debug('on click remove food pref : ', foodPref);
    if (this.viewMode) {
      return;
    }
    if (!foodPref) {
      this.inputPlayerTravelForm.foodPreference = [];
      return;
    }

    this.inputPlayerTravelForm.foodPreference = this.inputPlayerTravelForm?.foodPreference?.filter(
      fPref => {
        return fPref !== foodPref;
      }
    );
  }

  parseDate(date?: string) {
    if (!date) return '';
    return moment(date).format('dddd, DD MMM YYYY');
  }

  isModalOpen: boolean = false;
  selectedCountry: CountryData;
  async onCountrySelected() {
    if (this.viewMode) {
      return;
    }
    // Guard for the not open multiple time modal open
    if (this.isModalOpen) {
      return;
    }
    this.isModalOpen = true;
    try {
      const nationalityModal = await this.modalCtl.create({
        component: DeleteRoomModalComponent,
        cssClass: this.platform.is('mobile')
          ? 'self-favorite-adjustable-modal'
          : 'self-adjustable-modal-desktop',
        componentProps: {
          mode: 'selectClub',
          countryList: this.countryList,
          countryId: this.inputPlayerTravelForm?.passportCountryId,
          header: 'Select Country',
        },
        showBackdrop: true,
        mode: 'ios',
      });
      await nationalityModal.present();
      nationalityModal.onDidDismiss().then(data => {
        this.isModalOpen = false;
        if (data?.data) {
          console.log('data?.data: ', data?.data);
          this.inputPlayerTravelForm.passportCountryId = data?.data?.id;
          this.selectedCountry = data?.data;
        }
      });
    } catch (error) {
      this.isModalOpen = false;
    }
  }

  getFlagUrl() {
    const flagUrl = this.selectedCountry?.flagUrl;
    // console.debug('get flag url : ', this.selectedCountry, flagUrl);
    if (flagUrl === null) return null;
    else {
      let flagIcon = flagUrl?.split('/');
      const lastItem = flagIcon?.length - 1;
      return 'img/flag/' + flagIcon[lastItem];
    }
  }

  refreshParticipantsList() {
    this.multiCourseCompService.getParticipantsList().subscribe(participants => {
      this.participantsList = participants;
    });
  }

  getSharingRoomWithNames() {
    if (this.selectedSharingRoomWith?.length) {
      return this.selectedSharingRoomWith?.map(participant => participant?.name)?.join(', ');
    } else {
      return 'Select Sharing Room With';
    }
  }

  async onClickSave() {
    let _validateSuccess: boolean = true;
    // if (this.requireMandatory) {
    _validateSuccess = await this.onValidateForm();
    if (_validateSuccess) {
      this.getRoomAllocationId().subscribe(async (roomAllocationId: number) => {
        console.debug('get room allocation [000] : ', roomAllocationId, this.selectedRoomAllocated);
        try {
          let params = {};
          if (roomAllocationId) {
            this.getSpecificRoomAllocated(roomAllocationId, true).then((result: any) => {
              if (result) {
                params = result;
                params['startDate'] = moment(this.inputPlayerTravelForm.roomStayFrom).format(
                  'YYYY-MM-DD'
                );
                params['endDate'] = moment(this.inputPlayerTravelForm.roomStayUntil).format(
                  'YYYY-MM-DD'
                );
                this.flightService
                  .updateMCTSpecificRoom(this.leagueSeason?.id, params)
                  .subscribe(() => {
                    this.setRoomAllocationId(0);
                  });
              }
            });
          }
        } catch {}
      });
      this.onProcessSaveTravelInfo()
        .then((result: boolean) => {
          if (result) {
            MessageDisplayUtil.showMessageToast(
              'Successfully Saved Travel Info',
              this.platform,
              this.toastCtl,
              5000,
              'bottom'
            );
            this.modalCtl.dismiss();
          }
        })
        .catch(error => {
          if (error) {
            console.debug('error saving travel info : ', error);
            MessageDisplayUtil.showErrorToast(
              'Error Saving Travel Info',
              this.platform,
              this.toastCtl,
              5000,
              'bottom'
            );
          }
        })
        .finally(() => {});
    } else {
      MessageDisplayUtil.showErrorToast(
        this.validateMessage.join('<br>'),
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
    }
    // } else {
    //   this.proceedSubmit();
    // }
  }

  onProcessSaveTravelInfo() {
    return new Promise((resolve, reject) => {
      const _mctId = this.leagueSeason?.id;
      const _playerId = this.rosterDetails?.player?.id;
      console.debug(
        'on process save travel info [0] :',
        _mctId,
        _playerId,
        this.inputPlayerTravelForm
      );
      let _params = this.inputPlayerTravelForm;
      console.debug('on process save travel info [1]:', this.arrivalTime, this.departureTime);
      if (this.arrivalDate) _params['arrivalDate'] = moment(this.arrivalDate).format('YYYY-MM-DD');
      if (moment(this.arrivalTime).isValid()) {
        _params['arrivalTime'] = moment(this.arrivalTime, 'HH:mm').format('HH:mm:ss');
      } else {
        _params['arrivalTime'] = moment().format('HH:mm:ss');
      }
      if (this.departureDate)
        _params['departureDate'] = moment(this.departureDate).format('YYYY-MM-DD');
      if (moment(this.departureTime).isValid()) {
        _params['departureTime'] = moment(this.departureTime, 'HH:mm').format('HH:mm:ss');
      } else {
        _params['departureTime'] = moment().format('HH:mm:ss');
      }
      if (this.inputPlayerTravelForm?.passportExpiry)
        _params['passportExpiry'] = moment(this.inputPlayerTravelForm?.passportExpiry).format(
          'YYYY-MM-DD'
        );

      if (this.inputPlayerTravelForm?.arrivalByRoad) {
        _params['arrivingAirport'] = null;
        _params['arrivingFlightNumber'] = null;
      }
      if (this.inputPlayerTravelForm?.departureByRoad) {
        _params['departingAirport'] = null;
        _params['departingFlightNumber'] = null;
      }

      if (this.uploadedPassportFiles?.length) {
        if (_params['uploadPassportImages'] === undefined) _params['uploadPassportImages'] = null;
        _params['uploadPassportImages'] = this.uploadedPassportFiles[0]?.file;
        // this.uploadedPassportFiles?.forEach(passport => {
        //   if (_params['passportImages'] === undefined) _params['passportImages'] = [];
        //   _params['passportImages'].push(passport.file);
        // });
      }
      if (this.uploadedInsuranceFiles?.length) {
        if (_params['uploadInsuranceCopy'] === undefined) _params['uploadInsuranceCopy'] = null;
        _params['uploadInsuranceCopy'] = this.uploadedInsuranceFiles[0]?.file;
        // this.uploadedInsuranceFiles?.forEach(insurance => {
        //   if (_params['uploadInsuranceCopy'] === undefined) _params['uploadInsuranceCopy'] = [];
        //   _params['uploadInsuranceCopy'].push(insurance);
        // });
      }

      this.flightService.updateMCTPlayerTravelInfo(_mctId, _playerId, _params).subscribe(
        (data: MCTPlayerTravelInfo) => {
          console.debug('process save travel info [1] : ', data);
          this.setRoomAllocationId(data?.roomAllocationId);
          resolve(true);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  playerTravelInfo: any;
  getPlayerTravelInfo() {
    this.multiCourseCompService.getPlayerTravelInfo().subscribe(playerTravelInfo => {
      this.playerTravelInfo = playerTravelInfo;
      this.populatePlayerTravelForm();
    });
  }

  populatePlayerTravelForm() {
    // this.inputPlayerTravelForm = this.playerTravelInfo;
    for (let key in this.playerTravelInfo) {
      if (this.playerTravelInfo[key]) this.inputPlayerTravelForm[key] = this.playerTravelInfo[key];
      if (key === 'arrivalDate') this.arrivalDate = this.playerTravelInfo[key];
      if (key === 'departureDate') this.departureDate = this.playerTravelInfo[key];
      if (key === 'arrivalTime') this.arrivalTime = this.playerTravelInfo[key];
      if (key === 'departureTime') this.departureTime = this.playerTravelInfo[key];
      if (key === 'passportCountry')
        this.inputPlayerTravelForm[key] = this.playerTravelInfo['passportCountry']?.id;
    }
    this.refreshHotelList();
    console.debug(
      'populate travel info : ',
      this.playerTravelInfo,
      this.arrivalTime,
      this.departureTime
    );
    console.debug('populate travel form : ', this.inputPlayerTravelForm);
    console.debug('get hotel details [0] : ', this.hotelsList, this.hotelRooms);
    const _mctId = this.leagueSeason?.id;
    const _thId = this.playerTravelInfo?.tournamentHotelId;
    const _thrId = this.playerTravelInfo?.tournamentHotelRoomId;

    try {
      this.flightService
        .getMCTHotelDetails(_mctId, _thId)
        .subscribe((hotelDetails: TournamentHotel) => {
          console.debug('get hotel details [1] : ', hotelDetails);
          if (hotelDetails) {
            const hotelAddress = hotelDetails?.hotel?.address?.city
              ? `(${hotelDetails?.hotel?.address?.city}, ${hotelDetails?.hotel?.address?.state})`
              : '';
            this.selectedHotel = {
              id: hotelDetails?.id,
              name: `${hotelDetails?.hotel?.name} ${hotelAddress}`,
              data: hotelDetails,
            };
            if (hotelDetails?.hotelRooms?.length) {
              hotelDetails?.hotelRooms?.find(room => {
                if (room?.id === _thrId) {
                  this.selectedHotelRoom = {
                    id: room?.hotelRoom?.id,
                    name: room?.hotelRoom?.roomName,
                    data: room,
                  };
                  this.getHotelRoomAllocations(this.selectedHotelRoom);
                  this.getSpecificRoomAllocated();
                  // this.selectedHotelRoom.name = room?.hotelRoom?.roomName;
                }
              });
            }
          }
        });
      if (this.playerTravelInfo?.sharingPlayers?.length) {
        if (this.participantsList?.length) {
          this.participantsList?.forEach(ptcpt => {
            this.playerTravelInfo?.sharingPlayers.forEach(pId => {
              if (ptcpt?.player?.id === pId) {
                this.selectedSharingRoomWith.push({
                  id: pId,
                  name: ptcpt?.player?.playerName,
                });
              }
            });
          });
        }
      }
    } catch {
    } finally {
      this.selectedSharingRoomWith = this.mg2uUtil.getUnique(this.selectedSharingRoomWith, 'id');
      this.selectedCountry = this.playerTravelInfo?.passportCountry;
    }

    // this.selectedSharingRoomWith = this.inputPlayerTravelForm?.sharingRoomWith;

    // id?: number;
    // mctId?: number;
    // sctId?: number;
    // passportNumber?: string;
    // passportExpiry?: string;
    // passportCountryId?: string;
    // passportImages?: string; // binary data as string
    // arrivalDate?: string; // date format (YYYY-MM-DD)
    // arrivalTime?: string;
    // arrivingAirport?: string;
    // arrivingFlightNumber?: string;
    // departureDate?: string; // date format (YYYY-MM-DD)
    // departureTime?: string;
    // departingAirport?: string;
    // departingFlightNumber?: string;
    // foodPreference?: string[];
    // emergencyContactDetails?: TravelInfoEmergencyContactDetails; // complex object
    // insuranceName?: string;
    // insuranceNumber?: string;
    // insuranceCopy?: string; // binary data as string
    // roomAllocationId?: number;
    // tournamentHotelId?: number;
    // tournamentHotelRoomId?: number;
    // sharingRoomWith?: number[];
  }

  selectedRoomAllocated: any;
  roomStayFrom: string;
  roomStayUntil: string;
  getSpecificRoomAllocated(roomAllocationId?: number, toUpdateDates?: boolean) {
    return new Promise((resolve, reject) => {
      // console.debug('get hotel room allocations [0] : ', tourHotelData);
      const _multiCompCourseId = this.leagueSeason?.id;
      const _roomAllocationId = roomAllocationId | this.playerTravelInfo?.roomAllocationId;
      this.flightService
        .getMCTSpecificRoomAllocations(_multiCompCourseId, _roomAllocationId)
        .subscribe(
          (roomAllocated: any) => {
            this.selectedRoomAllocated = roomAllocated;
            if (!toUpdateDates) {
              if (roomAllocated?.startDate) {
                this.inputPlayerTravelForm.roomStayFrom = roomAllocated?.startDate;
                // this.roomStayFrom = roomAllocated?.startDate;
              }
              if (roomAllocated?.endDate) {
                this.inputPlayerTravelForm.roomStayUntil = roomAllocated?.endDate;
                // this.roomStayUntil = roomAllocated?.endDate;
              }
            }
            console.debug(
              'get hotel room allocations [11] : ',
              roomAllocated,
              this.inputPlayerTravelForm
            );
            resolve(roomAllocated);
          },
          error => {
            reject();
          }
        );
    });
  }

  getHotelRoomAllocations(tourHotelData: any) {
    console.debug('get hotel room allocations [0] : ', tourHotelData);
    const _multiCompCourseId = this.leagueSeason?.id;
    const tourHotelId = tourHotelData?.id;
    const tourHotelRoomId = tourHotelData?.data?.hotelRoom?.id;

    const roomAllocationId = this.playerTravelInfo?.roomAllocationId;
    this.flightService.getMCTSpecificRoomAllocations(_multiCompCourseId, roomAllocationId);
    this.flightService
      .getMCTAllRoomAllocations(_multiCompCourseId, tourHotelId, tourHotelRoomId)
      .subscribe((roomAllocations: any) => {
        this.selectedRoomAllocation = roomAllocations;
        console.debug('get hotel room allocations [1] : ', roomAllocations);
      });
  }
  selectedRoomAllocation: any;

  mctRoomAllocations: Array<any> = [];
  getAllHotelRoomAllocations() {
    const _multiCompCourseId = this.leagueSeason?.id;

    this.flightService
      .getMCTRoomAllocations(_multiCompCourseId)
      .subscribe((roomAllocations: any) => {
        console.debug('get hotel room allocations [1] : ', roomAllocations);
        this.mctRoomAllocations = roomAllocations;
      });
  }

  async onClickHotelDetails() {
    if (this.viewMode) {
      return;
    }
    if (this.lockStayDetails) {
      MessageDisplayUtil.showErrorToast(
        this.msgLockStayDetails,
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    }
    if (!this.selectedHotel) {
      MessageDisplayUtil.showErrorToast(
        'Please select a Hotel first',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    }

    if (this.playerTravelInfo?.roomNumber !== undefined && this.playerTravelInfo?.roomNumber) {
      MessageDisplayUtil.showErrorToast(
        'Please contact organizer as room has been allocated.',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    }
    let hotelRooms = [];

    try {
      const _mctId = this.leagueSeason?.id;
      this.flightService
        .getMCTHotelDetails(_mctId, this.selectedHotel?.id)
        .subscribe((hotelDetails: any) => {
          if (hotelDetails?.hotelRooms) {
            hotelRooms = hotelDetails?.hotelRooms;
            this.selectedHotel.data.hotelRooms = hotelRooms;
          }
        });
    } finally {
      const hotelDetailsModal = await this.modalCtl.create({
        component: HotelDetailsComponent,
        // cssClass: this.platform.is('mobile')
        //   ? 'self-favorite-adjustable-modal'
        //   : 'self-adjustable-modal-desktop',
        componentProps: {
          hotelDetails: this.selectedHotel?.data,
          hotelRooms: hotelRooms,
          // countryList: this.countryList,
          // countryId: this.inputPlayerTravelForm?.passportCountryId,
          headerTitle: 'View Hotel Details',
        },
        showBackdrop: true,
        mode: 'ios',
      });
      await hotelDetailsModal.present();
      hotelDetailsModal.onDidDismiss().then(data => {
        this.isModalOpen = false;
        if (data?.data) {
          console.log('hotel details data?.data: ', data?.data);

          // this.selectedHotelRoom = data?.data;
          // this.inputPlayerTravelForm.tournamentHotelRoomId = data?.data?.id;
          // this.getHotelRoomAllocations(data?.data);
          // this.inputPlayerTravelForm.passportCountryId = data?.data?.id;
          // this.selectedCountry = data?.data;
        }
      });
    }
  }

  onStyleHotelRooms() {
    if (this.selectedHotelRoom) {
      return 'height: auto';
    } else return 'max-height: 2rem';
  }
  onChangeDate(type: string, event: any) {
    if (!type) return;
    switch (type) {
      case 'arrival':
        if (!this.selectedRoomAllocated && this.arrivalDate) {
          this.inputPlayerTravelForm.roomStayFrom = this.arrivalDate;
          // this.roomStayFrom = this.arrivalDate;
        }
        break;
      case 'departure':
        if (!this.selectedRoomAllocated && this.departureDate) {
          this.inputPlayerTravelForm.roomStayUntil = this.departureDate;
          // this.roomStayUntil = this.departureDate;
        }
        break;
      case 'passportExpiry':
        break;
      case 'roomStayFrom':
        break;
      case 'roomStayUntil':
        break;
    }
  }
  roomAllocationId: BehaviorSubject<number> = new BehaviorSubject(0);

  getRoomAllocationId() {
    return this.roomAllocationId.asObservable();
  }

  setRoomAllocationId(roomAllocId: number) {
    this.roomAllocationId.next(roomAllocId);
  }
  handleImageError() {
    return;
  }
  participatingClubs: Array<any> = [];
  lockStayDetails: boolean = false;
  refreshParticipatingClubs() {
    const _multiCompCourseId = this.leagueSeason?.id;

    this.flightService
      .getMCTParticipatingClubs(_multiCompCourseId)
      .subscribe((participatingClubs: any) => {
        console.debug('refresh participating clubs : ', participatingClubs, this.rosterDetails);
        this.participatingClubs = participatingClubs;
        if (this.rosterDetails?.participatingClub) {
          this.lockStayDetails = this.participatingClubs?.find(pc => {
            return pc?.clubId === this.rosterDetails?.participatingClub?.id && pc?.lockedForChanges;
          });
        }
      });
  }
}
